module.exports = __webpack_public_path__ + "static/img/COLBY-McKERCHER.ce602cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COLBY-McKERCHER.jpg
// module id = XqIn
// module chunks = 0